// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"97a36116","424":"9abebde5","544":"145e3aa7","591":"6ee318dc","681":"d097f0ee"}[chunkId] + ".chunk.js";
};